import { useSelector } from 'react-redux';

import { selectUserRole } from 'src/reducers/userReducer/userReducer';
import { useGetAgentQaAccessQuery } from 'src/services/insights';
import { AgentAccessType } from 'src/services/insights/types';
import { UserRoles } from 'src/utils/enums';

export const useGetAgentAccess = () => {
  const role = useSelector(selectUserRole);
  const isAgentRole = role === UserRoles.ROLE_AGENT;
  const { data, error, isLoading } = useGetAgentQaAccessQuery(undefined, {
    skip: !isAgentRole,
  });

  let result: AgentAccessType | undefined = undefined;

  if (error) {
    const status = (error as { status?: number })?.status;
    if (status === 404) {
      result = 'not_available';
    } else {
      result = 'restricted';
    }
  }

  if (data) {
    result = 'available';
  }

  return { data: result, isLoading };
};
